<template>
  <div>
    <main>portfolio-bac.jpg
      <div id="HomeContainer" class="port">
          <div class="ContentAligher">

            <div class="row">
              <div class="col-md-5 col-md-offset-7">
                  <div id="HeroTitle">
                    <h1 class="bold"><span class="small">New York’s Finest</span>
                    <span class="mid">Elevator Interior </span>
                    <span>Design Expert</span></h1>

                    <p>experienced designers and craftsmen combine state-of-the-art technology with careful hand-finishing to produce superior quality custom-fabricate elevator cabs and cab interior finish systems. </p>

                    <a v-on:click="scrollMeTo('ReadMore');">View Our Designs</a>
                  </div>


              </div>
            </div>

          </div>
      </div>
    </main>
    <section class="ContentAligher SectionSpacing">
      
      <div class="row">
          <div class="col-md-10 col-md-offset-1">

              <h2 class="bold">Browse our styles</h2>

              <div class="FilterContainer">
                <form>
                  <div class="row">
                    <div class="col-md-2 col-sm-4 col-md-offset-4">
                      <input type="reset" name="reset" value="Reset">
                    </div>

                    <div class="col-md-2 col-sm-4">
                      <select name="filter_system" v-model="selected_filter_system">
                        <option value="">Systems</option>
                        <option v-for="(data, key, index) in filter_system":key="key" v-bind:value="{ id: data.project_system }">{{data.project_system}}</option>
                      </select>
                    </div>

                    <div class="col-md-2 col-sm-4">
                      <select name="filter_location" v-model="selected_filter_location">
                        <option value="">Location</option>
                        <option v-for="(data, key, index) in filter_location" :key="key" v-bind:value="{ id: data.project_location_city }">{{data.project_location_city}}</option>
                      </select>
                    </div>


                    <div class="col-md-2 col-sm-4">
                      <input type="button" name="submit" value="Filter" @click="FilterListing">
                    </div>

                  </div>
                </form>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div ref="ReadMore"></div>
                  
                  <div class="card text-center m-3">
                      <div class="card-footer pb-0 pt-3">
                          <jw-pagination :items="imgURL" @changePage="onChangePage" :pageSize="9"></jw-pagination>
                      </div>
                  </div>
                </div>

                <div class="col-md-4 col-sm-6" v-for="(data, key, index) in pageOfItems" :key="key">
                  <div class="padding-tb-16 relative"><router-link :to="'/portfolio/'+ data.id" >
                    <div class="TextOverlay">
                      <h3 class="bold">{{ data.project_location_city }}</h3>
                      <p  class="bold">{{ data.project_title }}</p>
                    </div>
                    <div class="portfolio_img"><img v-lazy-src="base_path + data.portfolio_images[0]"  class="responsive" @load="loaded" /></div></router-link></div>
                </div>


                <div class="col-md-12">               
                  <div class="card text-center m-3">
                      <div class="card-footer pb-0 pt-3">
                          <jw-pagination :items="imgURL" @changePage="onChangePage" :pageSize="9"></jw-pagination>
                      </div>
                  </div>
                </div>

                <div class="col-md-12" v-if="imgURL.length === 0">
                  <p>Sorry, No results found.</p>
                </div>
              </div>

        </div>
      </div>


    </section>
    <rwv-our-clients></rwv-our-clients>
    <rwv-general-form></rwv-general-form>
  </div>
</template>
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';


import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);


import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);


import '@/assets/js/easyResponsiveTabs'

import RwvGeneralForm from '@/components/GeneralForm';
import RwvOurClients from '@/components/OurClients';

Vue.directive('lazy-src',{
  inserted(el, { value }) {
    el.src = value

    /* Maybe we need to wait for nextTick, but trry without it first:
    Vue.nextTick(() => {
      el.src = value
    })  */
  },
  update(el, { value }) {
    el.src = value
  }
});





export default{
  name: 'Portfolio',
  components: {
    RwvGeneralForm, 
    RwvOurClients
  },
  data: function() {
    return {
      pageOfItems: [],
     // banner:require('./../../static/images/home.jpg'),
     base_path: BASE_URL,
     imgURL: [],
     filter_system:null,
     filter_location:null,
     selected_filter_system:'',
     selected_filter_location:'',
     limit: 3,
     busy: false,
     last_query: ''
    }
  },
  mounted() {
      $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });

      axios.get(API_BASE_URL + 'portfolio/filterables/project_location_city')
      .then(response => {this.filter_location = response.data});

      axios.get(API_BASE_URL + 'portfolio/filterables/project_system')
      .then(response => {this.filter_system = response.data});

      axios.get(API_BASE_URL + 'portfolio/list/')
      .then(response => {this.imgURL = response.data});

      this.last_query = API_BASE_URL + 'portfolio/list/';

      
  },
  updated(){
     //$('#processTab').easyResponsiveTabs({ tabidentify: 'vert', type: 'vertical' });
     //$(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
      }, 100);
  },
  methods: {
    loaded:function (e) {
      //console.log('111111111111111');
        $(this).trigger('resize');
    },
    FilterListing:function (e) {
      //console.log(this.selected_filter_system.id + ' ************ '+ this.selected_filter_location.id);

      if(this.selected_filter_system.id){
        var path1 = "project_system=" + encodeURIComponent(this.selected_filter_system.id) + "&";
      }else{
         var path1 = "";
      }

      if(this.selected_filter_location.id){
        var path2 = "project_location_city=" + encodeURIComponent(this.selected_filter_location.id);
      }else{
        var path2 = "";
      }
      
      //?project_location_city=Manhattan&project_system=Raised Removable
      axios.get(API_BASE_URL + 'portfolio/list/?' + path1+ path2 )
      /*axios.get(API_BASE_URL + 'portfolio/list/',{
            params: {
              project_system: path1,
              project_location_city: path2
            }
          })*/
      .then(response => {this.imgURL = response.data});

      this.last_query = API_BASE_URL + 'portfolio/list/?' + path1+ path2;
    },
    onChangePage(pageOfItems) {
        // update page of items
        this.pageOfItems = pageOfItems;
    },
    scrollMeTo(refName) {
        var element = this.$refs[refName];
        var top = element.offsetTop;
        window.scrollTo(0, top);
    },
  },
  computed: {
  }
  
}

</script>
<style>
@import './../assets/css/easyResponsiveTabs.css';
</style>


// WEBPACK FOOTER //
// src/views/Portfolio.vue